import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TextFieldModule } from '@angular/cdk/text-field';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-prompt-box',
  templateUrl: './prompt-box.component.html',
  styleUrls: ['./prompt-box.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    TextFieldModule
  ]
})
export class PromptBoxComponent {
  @Input() prompt = '';
  @Input() loading$: Observable<boolean> = new Observable<boolean>();
  @Input() label = '';
  @Input() disabled = false;

  @Output() promptChange = new EventEmitter<string>();
  @Output() sendMessageEvent = new EventEmitter<void>();
  @Output() clearSessionEvent = new EventEmitter<void>();

  onPromptChange() {
    this.promptChange.emit(this.prompt);
  }

  sendMessage() {
    this.sendMessageEvent.emit();
  }

  clearSession() {
    this.clearSessionEvent.emit();
  }
}
